import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { url: String };

  navigate(event) {
    // Don't navigate if clicking interactive elements
    if (
      event.target.closest(
        "a, button, [data-controller~='dropdown'], input, select, textarea",
      )
    ) {
      return;
    }

    // Don't navigate if selecting text
    if (window.getSelection().toString().length > 0) {
      return;
    }

    if (this.urlValue) {
      Turbo.visit(this.urlValue);
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      if (
        !event.target.closest(
          "a, button, [data-controller~='dropdown'], input, select, textarea",
        ) &&
        this.urlValue
      ) {
        Turbo.visit(this.urlValue);
      }
    }
  }
}
